import React, { useState, useEffect, useContext } from "react";

import { UserContext } from "../../App";

import ResponsiveDrawer from "../Drawer/drawer";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { Form } from "react-bootstrap";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { BiCloset, BiSearch } from "react-icons/bi";
import { IoClose } from "react-icons/io5";
import axios from "axios";
import Dropdown from "react-bootstrap/Dropdown";
import Notification from "../AlertNotification/Message";
import ConfirmDialog from "../AlertNotification/confirmdialog";
import { TextField, InputAdornment, Dialog, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import CircularIndeterminate from "../Loader/Loader";
import ImportCSV from "./importCSV";
import UploadImages from "./UploadImages";
import UpdatePrice from "./UpdatePrice";
import FilterColumnSelector from "../FilterColumnSelector";
////////////
////////////
////////////
const drawerWidth = 205;
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  <a
    href=""
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
    <span className="threedots" />
  </a>
));
const columns = [
  {
    id: "img",
    label: "Image",
    minWidth: 150,
    align: "left",
  },
  {
    id: "Season",
    label: "Season",
    minWidth: 30,
    align: "left",
    format: (value) => value.toFixed(2),
  },

  {
    id: "Factory",
    label: "Factory",
    minWidth: 30,
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "Stylename",
    label: "Style",
    minWidth: 30,
    align: "center",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "sku",
    label: "SKU",
    minWidth: 100,
    align: "left",
  },
  {
    id: "ArticleName",
    label: "Article\u000aName",
    minWidth: 100,
    align: "left",
  },

  {
    id: "Color",
    label: "Color",
    minWidth: 270,
    align: "left",
    format: (value) => value.toFixed(2),
  },
  { id: "Stitch", label: "Stitch\u00a0", minWidth: 120, align: "left" },
  {
    id: "size1",
    label: "Size1",
    minWidth: 80,
    align: "left",
    format: (value) => value.toFixed(2),
  },
  {
    id: "size2",
    label: "Size2",
    minWidth: 80,
    align: "left",
    format: (value) => value.toFixed(2),
  },
  {
    id: "size3",
    label: "Size3",
    minWidth: 80,
    align: "left",
    format: (value) => value.toFixed(2),
  },
  {
    id: "price1",
    label: "Price1",
    minWidth: 80,
    align: "left",
    format: (value) => value.toFixed(2),
  },

  {
    id: "price2",
    label: "Price2",
    minWidth: 50,
    align: "left",
    format: (value) => value.toFixed(2),
  },
  {
    id: "price3",
    label: "Price3",
    minWidth: 50,
    align: "left",
    format: (value) => value.toFixed(2),
  },
  {
    id: "action",
    label: "Action",
    minWidth: 10,
    align: "left",
    format: (value) => value.toFixed(2),
  },
];

const ProductThumbnail = React.memo(({ image, alt, onOpen }) => {
  const [imageError, setImageError] = useState(false);

  const isValid = Boolean(
    image &&
    typeof image === "string" &&
    image.trim() !== "" &&
    image !== "null" &&
    image !== "undefined" &&
    !imageError
  );

  if (!isValid) {
    return (
      <Box
        sx={{
          width: 150,
          height: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#f5f5f5",
          border: "1px dashed #ccc",
          borderRadius: 1,
          color: "#999",
          fontSize: "11px",
          textAlign: "center",
          userSelect: "none",
        }}
      >
        No Image
      </Box>
    );
  }

  return (
    <img
      src={image}
      className="newimagesproducts"
      alt={alt || "Product"}
      style={{
        maxWidth: 150,
        maxHeight: 100,
        objectFit: "contain",
        cursor: "pointer",
        borderRadius: "4px",
        overflow: "hidden",
        scale: "1.3"
      }}
      onError={() => setImageError(true)}
      onClick={() => onOpen(image)}
    />
  );
});

const filterableColumns = [
  { id: "sku", label: "SKU" },
  { id: "ArticleName", label: "Article Name" },
  { id: "Stylename", label: "Style Name" },
  { id: "Factory", label: "Factory" },
  { id: "Season", label: "Season" },
  { id: "Stitch", label: "Stitch" },
  { id: "Color", label: "Color" },
];

function AllProducts() {
  const navigate = useNavigate();
  const [filter, setfilter] = useState("");
  const [admins, setadmins] = useState([]);
  const [done, setdone] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState(
    filterableColumns.map((col) => col.id)
  );

  const handleSearchChange = (value) => {
    setfilter(value)
  }
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(1000);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const [open, setOpen] = React.useState(false);
  const [productImage, setProductImage] = useState("");

  const handleOpenProductImage = React.useCallback((image) => {
    if (
      !image ||
      typeof image !== "string" ||
      !image.trim() ||
      image === "null" ||
      image === "undefined"
    ) {
      return;
    }
    setProductImage(image);
    setOpen(true);
  }, []);

  const handleCloseProductImage = React.useCallback(() => {
    setOpen(false);
  }, []);

  useEffect(() => {
    setPage(0);
  }, [filter, selectedColumns]);

  const isColumnVisible = React.useCallback(
    (colId) => {
      const isFilterable = filterableColumns.some(
        (fc) => fc.id.toLowerCase() === colId.toLowerCase()
      );
      if (!isFilterable) {
        return true;
      }
      if (!selectedColumns || selectedColumns.length === 0) {
        return true;
      }
      return selectedColumns.some(
        (sc) => sc.toLowerCase() === colId.toLowerCase()
      );
    },
    [selectedColumns]
  );

  const filteredAdmins = React.useMemo(() => {
    if (!filter || !filter.trim()) {
      return admins;
    }
    const lowerFilter = filter.toString().toLowerCase().trim();
    const words = lowerFilter.split(/\s+/).filter(Boolean);

    return admins.filter((admin) => {
      if (!admin) return false;

      const sku = (admin.sku ?? admin.SKU ?? admin.Sku ?? "").toString().toLowerCase();
      const article = (admin.ArticleName ?? admin.articleName ?? admin.articlename ?? "").toString().toLowerCase();
      const style = (
        admin.Stylename ??
        admin.StyleName ??
        admin.styleName ??
        admin.StyleFactory ??
        admin.styleFactory ??
        admin.Style ??
        ""
      ).toString().toLowerCase();
      const factory = (admin.Factory ?? admin.factory ?? "").toString().toLowerCase();
      const season = (admin.Season ?? admin.season ?? "").toString().toLowerCase();
      const stitch = (admin.Stitch ?? admin.stitch ?? "").toString().toLowerCase();

      const colorParts = [
        admin.Color,
        admin.color,
        admin.Material1,
        admin.Material2,
        admin.Material3,
        admin.Material4,
        admin.Material5,
        admin.Material6,
      ].filter(Boolean);

      const colorJoined =
        colorParts.join(" ").toLowerCase() +
        " " +
        colorParts.join("/").toLowerCase();

      const fullText = `${sku} ${article} ${style} ${factory} ${season} ${stitch} ${colorJoined}`;

      return words.every((word) => fullText.includes(word));
    });
  }, [admins, filter]);

  const paginatedAdmins = React.useMemo(() => {
    return filteredAdmins.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
  }, [filteredAdmins, page, rowsPerPage]);
  const [tokenauth, settokenauth] = useState("");

  const GetAdmins = () => {
    axios
      .post("/get-token", {
        id: sessionStorage.getItem("token_id"),
      })
      .then((res) => {
        settokenauth(res.data.token);
        axios
          .get(`/get-products`, {
            headers: {
              "x-auth-header": res.data.token,
            },
          })
          .then((response) => {
            setadmins(response.data);
            setdone(true);
          })
          .catch((err) => console.log(err.response));
      })
      .catch((err) => console.log(err));
    // console.log(response.data);
  };

  useEffect(() => {
    sessionStorage.getItem("payloadout") != "true"
      ? navigate("/")
      : sessionStorage.setItem("id", "3");
    GetAdmins();
  }, []);

  const handleDelete = (sku) => {
    // console.log(sku);
    setdone(true);

    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    axios
      .post(
        "/delete-product-data",
        {
          sku: sku,
        },
        {
          headers: {
            "x-auth-header": tokenauth,
          },
        }
      )
      .then((response) => {
        setdone(false);
        console.log(response.status);
        if (response.status === 200) {
          setdone(false);
          setNotify({
            isOpen: true,
            message: "Product Deleted Successfully",
            // message: `${response.data.message}`,
            type: "success",
          });
        }
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((err) => {
        setdone(false);
        console.log(err.status);
        setNotify({
          isOpen: true,
          message: `${err.response}`,
          type: "error",
        });
        // console.log(err);
      });
  };
  const [csv, setcsv] = useState(true);
  const [images, setimages] = useState(true);
  const [price, setprice] = useState(true);

  const handleCSVopen = () => {
    setcsv(!csv);
    setimages(true);
    setprice(true);
  };

  const handleImagesOpen = () => {
    setcsv(true);
    setimages(!images);
    setprice(true);
  };

  const handleUpdatePricesOpen = () => {
    setcsv(true);
    setimages(true);
    setprice(!price);
  };

  const DeleteAllProducts = () => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    setdone(true);
    axios
      .post(
        "/delete-products",
        {},
        {
          headers: {
            "x-auth-header": tokenauth,
          },
        }
      )
      .then((response) => {
        console.log(response.status);
        if (response.status === 200) {
          setdone(false);
          setNotify({
            isOpen: true,
            message: "All Products Deleted Successfully",
            // message: `${response.data.message}`,
            type: "success",
          });
        }
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((err) => {
        setdone(false);
        console.log(err.response);
        setNotify({
          isOpen: true,
          message: `${err.response}`,
          type: "error",
        });
      });
  };
  /////IMAGE PAPUP//////
  const [isOpen, setisOpen] = useState(false);

  return (
    <div className="tableX">
      <ResponsiveDrawer heading="Product Management" />
      <Box
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
        component="main"
      >
        <Toolbar />
        {!done ? (
          <CircularIndeterminate className="allagentsLoader" />
        ) : (
          <div className="position-relative">
            <div className=" d-flex justify-content-between p-4">
              <h4 className="">All&nbsp;Products</h4>
              <div className="Accordian">
                <div className="one">
                  <div className="btncsv">
                    <button className="btn1 mb-2 px-3" onClick={handleCSVopen}>
                      <small>Import&nbsp;CSV</small>
                    </button>
                  </div>
                </div>
                <div className="mx-2">
                  <div className="btncsv">
                    <button
                      className="btn1 mb-3 px-2"
                      onClick={handleImagesOpen}
                    >
                      <small>Upload&nbsp;Image</small>
                    </button>
                  </div>
                </div>
                <div className="ImportCSV1">
                  <div className="btncsv">
                    <button
                      className="btn1 mb-3 px-2"
                      onClick={handleUpdatePricesOpen}
                    >
                      <small>Update&nbsp;Prices</small>
                    </button>
                  </div>
                </div>
                <div className="ImportCSV1">
                  <div className="ms-2">
                    <button
                      className="btnxcv mb-3 px-3"
                      onClick={() => {
                        setConfirmDialog({
                          isOpen: true,
                          title: "Delete All Products?",
                          subTitle: "You can't undo this operation",
                          onConfirm: () => {
                            DeleteAllProducts();
                          },
                        });
                      }}
                    >
                      <small>Delete&nbsp;All&nbsp;Products</small>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className={!csv ? null : "main11"}>
              <ImportCSV />
            </div>{" "}
            <div className={!images ? null : "main11"}>
              <UploadImages />
            </div>
            <div className={!price ? null : "main11"}>
              <UpdatePrice />
            </div>
            <div className="d-flex flex-column flex-md-row align-items-start align-items-md-end mx-4 mb-3 gap-3">
              <small
                className="fw-bolder"
                style={{ minWidth: "fit-content", paddingBottom: "8px" }}
              >
                Search&nbsp;By
              </small>
              <div style={{ width: "20rem" }}>
                <Form onSubmit={(e) => e.preventDefault()} className="position-relative">
                  <Form.Control
                    placeholder="SKU, ArticleName, StyleName, or Color"
                    type="search"
                    className="input_field"
                    value={filter}
                    onChange={(e) => handleSearchChange(e.target.value)}
                    style={{ width: "20rem" }}
                  />
                  <IoClose className="search_Agent" style={{ right: "1ch", cursor: "pointer", display: (filter.length == 0) && "none" }} onClick={() => { setfilter("") }} />
                </Form>
              </div>
              <FilterColumnSelector
                filterableColumns={filterableColumns}
                selectedColumns={selectedColumns}
                setSelectedColumns={setSelectedColumns}
                placeholder="Select columns to filter by..."
                minWidth="20rem"
                maxWidth="20rem"
                style={{ width: "20rem" }}
              />
            </div>
            <div className="for__table mx-4 my-3">
              <Paper sx={{ width: "100%", overflow: "hidden" }}>
                <TableContainer sx={{ height: "calc(100vh - 280px)", overflow: "auto" }}>
                  <Table stickyHeader aria-label="sticky table bg-white">
                    <TableHead>
                      <TableRow>
                        {columns
                          .filter((column) => isColumnVisible(column.id))
                          .map((column) => (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              style={{ minWidth: column.minWidth }}
                            >
                              {column.label}
                            </TableCell>
                          ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {paginatedAdmins.map((admin) => {
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={admin._id}
                          >
                            <TableCell>
                              <ProductThumbnail
                                image={admin.Picture}
                                alt={admin.ArticleName}
                                onOpen={handleOpenProductImage}
                              />
                            </TableCell>

                            {isColumnVisible("Season") && (
                              <TableCell>{admin.Season}</TableCell>
                            )}
                            {isColumnVisible("Factory") && (
                              <TableCell>{admin.Factory}</TableCell>
                            )}

                            {isColumnVisible("Stylename") && (
                              <TableCell>{admin.Stylename}</TableCell>
                            )}
                            {isColumnVisible("sku") && (
                              <TableCell>{admin.sku}</TableCell>
                            )}
                            {isColumnVisible("ArticleName") && (
                              <TableCell>{admin.ArticleName}</TableCell>
                            )}
                            {isColumnVisible("Color") && (
                              <TableCell>
                                {admin.Material1 == "" ||
                                  admin.Material1 == null
                                  ? ""
                                  : admin.Material1}

                                {admin.Material2 == "" ||
                                  admin.Material2 == null
                                  ? ""
                                  : "/" + admin.Material2}

                                {admin.Material3 == "" ||
                                  admin.Material3 == null
                                  ? ""
                                  : "/" + admin.Material3}
                              </TableCell>
                            )}

                            {isColumnVisible("Stitch") && (
                              <TableCell>{admin.Stitch}</TableCell>
                            )}

                            <TableCell>{admin.Size1}</TableCell>
                            <TableCell>{admin.Size2}</TableCell>
                            <TableCell>{admin.Size3}</TableCell>

                            <TableCell>{admin.Price1}</TableCell>
                            <TableCell>{admin.Price2}</TableCell>
                            <TableCell>{admin.Price3}</TableCell>

                            <TableCell>
                              <div className="App">
                                <Dropdown className="">
                                  <Dropdown.Toggle as={CustomToggle} />
                                  <Dropdown.Menu className="">
                                    <Dropdown.Item className="bg-white">
                                      {" "}
                                      <span
                                        onClick={() => {
                                          navigate(
                                            `/ViewProduct/${admin._id}`
                                          );
                                        }}
                                        className="abc"
                                      >
                                        View
                                      </span>
                                    </Dropdown.Item>
                                    <Dropdown.Item className="bg-white">
                                      {" "}
                                      <span
                                        onClick={() => {
                                          navigate(
                                            `/ProductDetails/${admin._id}`
                                          );
                                        }}
                                        className="abc"
                                      >
                                        Edit
                                      </span>
                                    </Dropdown.Item>
                                    <Dropdown.Item className="bg-white">
                                      <span
                                        className="abc"
                                        onClick={() => {
                                          // setConfirmDialog({
                                          //   isOpen: true,
                                          //   title:
                                          //     "Are you sure to delete this record?",
                                          //   subTitle:
                                          //     "You can't undo this operation",
                                          // onConfirm: () => {
                                          handleDelete(admin.sku);
                                          //   },
                                          // });
                                        }}
                                      >
                                        Delete
                                      </span>
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  className="mx-5 mt-3 px-5"
                  rowsPerPageOptions={[1000, 2000, 4000]}
                  component="div"
                  count={filteredAdmins.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>
            </div>
          </div>
        )}
      </Box>
      <Notification notify={notify} setNotify={setNotify} />
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />

      <Dialog
        open={open}
        onClose={handleCloseProductImage}
        maxWidth="md"
        PaperProps={{
          sx: {
            position: "relative",
            p: 2,
            bgcolor: "#fff",
            borderRadius: 2,
            boxShadow: 24,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            maxWidth: "90vw",
            maxHeight: "90vh",
            overflow: "hidden",
          },
        }}
      >
        <IconButton
          aria-label="close"
          onClick={handleCloseProductImage}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[600],
            backgroundColor: "rgba(255, 255, 255, 0.85)",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 1)",
            },
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 1,
            maxHeight: "80vh",
            maxWidth: "80vw",
          }}
        >
          <img
            src={productImage}
            alt="Product Preview"
            style={{
              maxWidth: "100%",
              maxHeight: "75vh",
              objectFit: "contain",
              borderRadius: "8px",
            }}
          />
        </Box>
      </Dialog>
    </div>
  );
}

export default AllProducts;
